import { Controller, useFormContext } from 'react-hook-form';
import { Box, Chip, Stack, TextFieldProps } from '@mui/material';
import { ColorSchema } from '../../theme/palette';
import ErrorComponent from './error-component';

type Option = {
  label: string;
  value: string;
  color: ColorSchema;
};

export type RHFToggleButtonGroupProps = TextFieldProps & {
  name: string;
  options: Option[];
  primary: boolean;
};

const RHFToggleButtonGroup = ({ sx, name, options, disabled, size, primary, onClick }: RHFToggleButtonGroupProps) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => {
        return (
          <Stack>
            <Stack direction="row" spacing={1} sx={sx}>
              {options.map((option) => (
                <Chip
                  key={option.value}
                  label={option.label}
                  id={option.value}
                  clickable
                  disabled={disabled}
                  onClick={(e) => {
                    if (onClick) {
                      onClick(e, option.value);
                    }
                    field.onChange(option.value);
                  }}
                  color={field.value === option.value ? option?.color : 'default'}
                  variant={primary ? 'outlined' : field.value === option.value ? 'filled' : 'outlined'}
                  size={size}
                />
              ))}
            </Stack>
            {error?.message && (
              <Box sx={{ mt: 0.5, ml: 1 }}>
                <ErrorComponent state="error"  message={error?.message} />
              </Box>
            )}
          </Stack>
        );
      }}
    />
  );
};

export default RHFToggleButtonGroup;
